import * as Immutable from "immutable";
import { LOAD_REPORT, TIMELINE_TASK_DELETED, TIMELINE_TASK_UPDATED } from "~/store/action_types";

/**
 * Get location of the task inside the timeline
 *
 * @param {Object} argTask - a task we search for
 * @param {Boolean} isTeamTimeline - weather we're working with team or project timeline, as their structure differs
 * @return {Array} an array of path components
 */
function getTaskPath(argTask, isTeamTimeline) {
  let levelOne = `project-${argTask.project_id}`;
  let levelTwo = `task-list-${argTask.task_list_id}`;

  if (isTeamTimeline) {
    levelOne = `user-${argTask.assignee_id}`;
    levelTwo = `project-${argTask.project_id}`;
  }

  return [levelOne, "assignments", levelTwo, "assignments", `${argTask.id}`];
}

/**
 * Update task on project timeline after editing through modal
 * @param  {Immutable.map} state Immutable state
 * @param  {Object} task  a task to update
 * @return {Immutable.map}       New state
 */
function performTaskDeletionOnProjectTimeline(state, task) {
  const path = getTaskPath(task, /user/.test(Object.keys(state.toJS()).pop()));
  return state.deleteIn(path);
}

/**
 * Update task on project timeline after editing through modal
 * @param  {Immutable.map} state Immutable state
 * @param  {Object} argTask  a task to update
 * @return {Immutable.map}       New state
 */
function updateTaskInTimeline(state, argTask) {
  const isTeamTimeline = /user/.test(Object.keys(state.toJS()).pop());
  const path = getTaskPath(argTask, isTeamTimeline);
  const oldTask = state.getIn(path);
  // check if there's an existing task on particular path
  // if not, it means we've changed task lists
  if (!oldTask) {
    // build updated report Map
    const newMap = state.map((project) => {
      var lists = project.get("assignments");
      // Delete old task if it exists (.deleteIn doesn't throw an error if no task)
      var newLists = lists
        .map((list) => {
          return list.deleteIn(["assignments", `${argTask.id}`]);
        })
        .filter((list) => list.get("assignments").size); // remove empty lists
      // save updated list without deleted task
      return project.set("assignments", newLists);
    });
    return newMap.setIn(path, Immutable.Map(argTask));
  }
  // and set correct one
  return state.setIn(path, Immutable.Map(Object.assign(oldTask.toJS(), argTask)));
}

/**
 * Handles report actions
 * @param {Immutable.Map}  state   App's old state object
 * @param {Object}         action  Standard flux action
 * @return {Immutable.Map}         New and updated state object
 */
const report = (state = Immutable.Map(), action) => {
  switch (action.type) {
    case TIMELINE_TASK_DELETED:
      return performTaskDeletionOnProjectTimeline(state, action.payload);

    case TIMELINE_TASK_UPDATED:
      return updateTaskInTimeline(state, action.payload);

    case LOAD_REPORT:
      return Immutable.fromJS(action.response);

    default:
      return state;
  }
};

export default report;
